import { TableActions } from "../../../components/tables/tableContext/TableContext";
import TableWidget from "../../../components/tables/TableWidget";
import { fetchUndeliveredPackagesCentralizer } from "../../../redux/api/raports.api";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  getUndeliveredPackagesCentralizerTableData,
  undeliveredPackagesCentralizerTableHeader,
} from "./components/tableConfigs/undeliveredPackagesCentralizerTableConfig";

function UndeliveredPackagesCentralizer() {
  const dispatch = useAppDispatch();
  const {
    raports: {
      undeliveredPackagesCentralizer: {
        data: {
          data: undeliveredPackagesCentralizerData,
          total: totalUndeliveredPackagesCentralizer,
        },
        isLoading: isLoadingUndeliveredPackagesCentralizer,
      },
    },
  } = useAppSelector((state) => ({
    raports: state.raports,
  }));

  const handleScannedPackagesTableActions = (action: TableActions) => {
    if (action.tablePagination.page && action.tablePagination.rowsPerPage) {
      dispatch(
        fetchUndeliveredPackagesCentralizer({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
        }),
      );
    }
  };

  return (
    <TableWidget
      tableTitle="Centralizator colete nelivrate"
      tableHeaderData={undeliveredPackagesCentralizerTableHeader}
      tableItemsData={getUndeliveredPackagesCentralizerTableData(
        undeliveredPackagesCentralizerData,
      )}
      totalItems={totalUndeliveredPackagesCentralizer}
      tableLoading={isLoadingUndeliveredPackagesCentralizer}
      handleTableActions={handleScannedPackagesTableActions}
      borderedRow
    />
  );
}

export default UndeliveredPackagesCentralizer;
